import { useRecoilValue } from "recoil";
import upperDataStore from "src/stores/upperData";

import OddConverter from '@common/helpers/oddConverter';
import { useConfig } from "src/hooks/config";

interface IProps {
    price: number;
};

const Odd = ({ price }: IProps) => {
    const config = useConfig();
    const { oddsFormat } = useRecoilValue(upperDataStore);
    
    // TODO: implement odd converter without dependency from @common
    return <>{OddConverter(config, price, oddsFormat)}</>;
};

export default Odd;